module.exports = __webpack_public_path__ + "static/doginbox-d7bfbc939ca8e7d301fd5a7a281bc069.jpg";